import { frontendURL } from '../../../helper/URLHelper';
import CalendarIndex from './pages/CalendarIndex.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CALENDAR,
  permissions: ['administrator', 'agent'],
  installationTypes: [
    INSTALLATION_TYPES.CLOUD,
    INSTALLATION_TYPES.ENTERPRISE,
    INSTALLATION_TYPES.COMMUNITY,
  ],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/calendar'),
    component: CalendarIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'calendar_dashboard_index',
        component: CalendarIndex,
        meta: commonMeta,
      },
    ],
  },
];
